import { createMemoryHistory } from 'history';

const history = createMemoryHistory({
    basename: '/',
    hashType: 'slash',
    getUserConfirmation: (message, callback) => callback(window.confirm(message))
})

export default history;